<div class="main-container">
    <div class="header-container">
        <ng-container *ngIf="_commonService.isMobile()">
            <div class="header-row" *ngIf="transactionDetail$ | async as transactionDetail">
                <div class="icon-class">
                    <div class="product-img-wrapper">
                        <ng-container *ngIf="transactionDetail.merchantData">
                            <img [src]="'./assets/images/trxicons/' + transactionDetail.merchantData.icon" alt=""
                                *ngIf="transactionDetail.merchantData.icon != ''" />
                            <i class="icon ico-secure-payment" *ngIf="transactionDetail.merchantData.icon == ''"></i>
                        </ng-container>
                        <ng-container *ngIf="transactionDetail.transactionCodeData">
                            <img [src]="'./assets/images/trxicons/' + transactionDetail.transactionCodeData.icon" alt=""
                                *ngIf="transactionDetail.transactionCodeData.icon != ''" />
                            <i class="icon ico-secure-payment"
                                *ngIf="transactionDetail.transactionCodeData.icon == ''"></i>
                        </ng-container>
                        <ng-container *ngIf="!transactionDetail.merchantData && !transactionDetail.transactionCodeData">
                            <i class="icon ico-secure-payment"></i>
                        </ng-container>
                    </div>
                </div>
                <div class="header-info">
                    <span class="date">{{transactionDetail.transactionDate | dateFormatter: "yyyy-mm-dd" }}</span>
                    <ng-container *ngIf="transactionDetail.merchantData; else noMerchantTtl">
                        <span class="store-name">{{ transactionDetail.merchantData.merchantName }}</span>
                    </ng-container>

                    <ng-template #noMerchantTtl>
                        <span class="store-name">{{ transactionDetail.transactionDesc }}</span>
                    </ng-template>
                    <span class="store-sname">{{ transactionDetail.transactionRemarks }}</span>
                    <div class="trx-type-amount">
                        <div class="tag-wrap">
                            <ng-container *ngIf="transactionDetail.merchantData; else noMerchantTag">
                                <span class="tag">{{ transactionDetail.merchantData.merchantCat }}</span>
                            </ng-container>

                            <ng-template #noMerchantTag>
                                <span class="tag">{{ transactionDetail.transactionCodeData.tranCatType }}</span>
                            </ng-template>
                        </div>
                        <div class="amt-group">
                            <span class="amt" [ngClass]="{ credit: transactionDetail.dbcrFlag == 'C' }">
                                <span *ngIf="transactionDetail.dbcrFlag == 'D'">-</span><span
                                    *ngIf="transactionDetail.dbcrFlag == 'C'">+</span>
                                {{ _commonService.formatAmount(transactionDetail.transactionAmount) }}</span>&nbsp;
                            <span class="amt-type">{{transactionDetail.transactionCurrency}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="_commonService.isDesktop()">
            <div class="header-row" *ngIf="transactionDetail$ | async as transactionDetail">
                <div class="icon-class">
                    <div class="product-img-wrapper">
                        <ng-container *ngIf="transactionDetail.merchantData">
                            <img [src]="'./assets/images/trxicons/' + transactionDetail.merchantData.icon" alt=""
                                *ngIf="transactionDetail.merchantData.icon != ''" />
                            <i class="icon ico-secure-payment" *ngIf="transactionDetail.merchantData.icon == ''"></i>
                        </ng-container>
                        <ng-container *ngIf="transactionDetail.transactionCodeData">
                            <img [src]="'./assets/images/trxicons/' + transactionDetail.transactionCodeData.icon" alt=""
                                *ngIf="transactionDetail.transactionCodeData.icon != ''" />
                            <i class="icon ico-secure-payment"
                                *ngIf="transactionDetail.transactionCodeData.icon == ''"></i>
                        </ng-container>
                        <ng-container *ngIf="!transactionDetail.merchantData && !transactionDetail.transactionCodeData">
                            <i class="icon ico-secure-payment"></i>
                        </ng-container>
                    </div>
                </div>
                <div class="header-info">
                    <span class="date">{{transactionDetail.transactionDate | dateFormatter: "yyyy-mm-dd" }}</span>
                    <ng-container *ngIf="transactionDetail.merchantData; else noMerchantTtl">
                        <span class="store-name">{{ transactionDetail.merchantData.merchantName }}</span>
                    </ng-container>

                    <ng-template #noMerchantTtl>
                        <span class="store-name">{{ transactionDetail.transactionDesc }}</span>
                    </ng-template>
                    <span class="store-sname">{{ transactionDetail.transactionRemarks }}</span>
                    <div class="trx-type-amount">
                        <div class="tag-wrap">
                            <ng-container *ngIf="transactionDetail.merchantData; else noMerchantTag">
                                <span class="tag">{{ transactionDetail.merchantData.merchantCat }}</span>
                            </ng-container>

                            <ng-template #noMerchantTag>
                                <span class="tag">{{ transactionDetail.transactionCodeData.tranCatType }}</span>
                            </ng-template>
                        </div>
                        <div class="amt-group">
                            <span class="amt" [ngClass]="{ credit: transactionDetail.dbcrFlag == 'C' }">
                                <span *ngIf="transactionDetail.dbcrFlag == 'D'">-</span><span
                                    *ngIf="transactionDetail.dbcrFlag == 'C'">+</span>
                                {{ _commonService.formatAmount(transactionDetail.transactionAmount) }}</span>&nbsp;
                            <span class="amt-type">{{transactionDetail.transactionCurrency}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="transacions-container" *ngIf="transactionInfo$ | async as transactionInfo">
        <h6 class="trans-title">{{'TRANSACTIONINFO.header'| translate}}</h6>
        <div class="body-container">
            <div class="row trans-row">
                <div class="col-9 body-col-one">
                    <span class="b-text1">{{'TRANSACTIONINFO.transactionReference'| translate}}</span>
                    <br />
                    <span class="b-text2">{{transactionInfo.transactionRef}}</span>
                </div>
                <div class="col-3 image-grp">
                    <!-- <img clickable height="40px" width="40px" src="./assets/images/download.gif" alt="download_gif" /> -->
                </div>
            </div>
            <div class="row trans-row">
                <div class="col-9 body-col-one">
                    <span class="b-text1">{{'TRANSACTIONINFO.beneficiaryName'| translate}}</span>
                    <br />
                    <span class="b-text2">{{transactionInfo.beneficiaryName}}</span>
                </div>
                <div class="col-3 image-grp"></div>
            </div>
            <div class="row trans-row">
                <div class="col-9 body-col-one">
                    <span class="b-text1">{{'TRANSACTIONINFO.beneficiaryAccount'| translate}}</span>
                    <br />
                    <span class="b-text2">{{transactionInfo.beneficiaryAccount}}</span>
                </div>
                <div class="col-3 image-grp"></div>
            </div>
            <div class="row trans-row">
                <div class="col-9 body-col-one">
                    <span class="b-text1">{{'TRANSACTIONINFO.beneficiaryBank'| translate}}</span>
                    <br />
                    <span class="b-text2">{{transactionInfo.beneficiaryBank}}</span>
                </div>
                <div class="col-3 image-grp"></div>
            </div>
            <div class="row trans-row">
                <div class="col-9 body-col-one">
                    <span class="b-text1">{{'TRANSACTIONINFO.payerName'| translate}}</span>
                    <br />
                    <span class="b-text2">{{transactionInfo.payerName}}</span>
                </div>
                <div class="col-3 image-grp"></div>
            </div>
            <div class="row trans-row">
                <div class="col-9 body-col-one">
                    <span class="b-text1">{{'TRANSACTIONINFO.payerAccount'| translate}}</span>
                    <br />
                    <span class="b-text2">{{transactionInfo.payerAccount}}</span>
                </div>
                <div class="col-3 image-grp"></div>
            </div>
            <div class="row trans-row">
                <div class="col-9 body-col-one">
                    <span class="b-text1">{{'TRANSACTIONINFO.payerBankName'| translate}}</span>
                    <br />
                    <span class="b-text2">{{transactionInfo.payerBankName}}</span>
                </div>
                <div class="col-3 image-grp"></div>
            </div>
            <div class="row trans-row">
                <div class="col-9 body-col-one">
                    <span class="b-text1">{{'TRANSACTIONINFO.transactionDescription'| translate}}</span>
                    <br />
                    <span class="b-text2">{{transactionInfo.transactionDesc}}</span>
                </div>
                <div class="col-3 image-grp"></div>
            </div>
            <div class="row trans-row">
                <div class="col-9 body-col-one">
                    <span class="b-text1">{{'TRANSACTIONINFO.transactionStatus'| translate}}</span>
                    <br />
                    <span class="b-text2">{{ transactionInfo.transactionStatus }}</span>
                </div>
                <div class="col-3 image-grp"></div>
            </div>
        </div>
    </div>
</div>